import Vue from "vue";

export const NotificationReloadEventBus = new Vue();
